import React, { useState, useEffect } from "react";

import usePagination from "hooks/usePagination";
import { isMobile } from "helpers/Mobile";

import InputText from "components/MainApp/atoms/Forms/MainInput";
import ItemLocalization from "components/MainApp/organisms/Stock/ItemLocalization";
import Toggle from "components/MainApp/atoms/Forms/Toggle";
import Pagination from "components/MainApp/atoms/Pagination";

import DeviceSelector from "components/Functionals/DeviceSelector";

import styles from "./LocalizationItems.module.scss";
import i18n from "i18n";
import TagReadInput from "shared/components/Input/TagReadInput";

export const LocalizationItems = ({
  enabledRead,
  typeRead,
  refRead,
  receiveEvent,
  groupItems = [],
  groupSimilarItems = [],
  total,
  handleSimilarStatus,
  similar,
  handleSearch,
  handleDelete,
  handleDeleteAll,
  onDeviceError
}) => {
  const [searchedValue, setsearchedValue] = useState("");

  const [
    list,
    currentPage,
    pageSize,
    pageList,
    pageQuantity,
    changePageSize,
    changePage,
    changeList
  ] = usePagination([], 1, 3);

  useEffect(() => {
    changeList(groupItems, currentPage, pageSize);
  }, [groupItems]);

  const searchValue = e => {
    setsearchedValue(e.target.value.trim());
  };

  const handleSubmit = function (e) {
    e.preventDefault();
    handleSearch(searchedValue);
    setsearchedValue("");
  };

  return (
    <div className={styles["localization-items-outter"]}>
      <div className={styles["localization-items-wrapper"]}>
        <div className={`${styles["localization-items-device-selector"]} ${styles["custom-mobile-align-right"]}`}>
          <DeviceSelector
            enabled={enabledRead}
            typeRead={typeRead}
            refRead={refRead}
            receiveEvent={receiveEvent}
            onDeviceError={onDeviceError}
            includeType={"MOB_READER"}
          />
        </div>
        <div className={styles["localization-items-content"]}>
          <div className={styles["localization-items-input-wrapper"]}>
              <TagReadInput searchValue={searchValue} searchedValue={searchedValue} handleSubmit={handleSubmit} />
          </div>
          <div className={styles["localization-items-bottom"]}>
            <div className={styles["localization-items-toggle"] + ' ' + styles["similars"]}>
              <p>{i18n.t("show.similar.products")}</p>
              <Toggle
                handleChange={handleSimilarStatus}
                checked={similar}
                name="similar"
              />
            </div>
            {!isMobile && groupItems.length > 0 && (
              <div className={styles["localization-items-buttons-wrapper"]}>
                <div
                  className={styles["localization-items-button"] + ' ' + styles["localization-items-clean"]}
                  onClick={handleDeleteAll}
                >
                  {i18n.t("clean")}
                </div>
              </div>
            )}
          </div>

          {groupItems.length > 0 && (
            <div className={styles["localization-items-count"]}>{total}</div>
          )}
        </div>
        {groupItems.length > 0 && (
          <div className={styles["localization-items-content"]}>
            <div className={styles["localization-items-list"]}>
              {pageList.map(item => {
                return (
                  <ItemLocalization
                    key={`${item.sku}-${item.loc_id}`}
                    item={item}
                    quantity={item.tags.length}
                  />
                );
              })}
            </div>

            {!similar && groupItems.length > 0 && (
              <div>
                <Pagination
                  pageQuantity={pageQuantity}
                  currentPage={currentPage}
                  pageChangeHandler={changePage}
                />
              </div>
            )}
          </div>
        )}
        {similar && groupItems.length > 0 && (
          <div className={styles["localization-items-content"]}>
            <h3 className={styles["localization-items-similar-title"]}>
              {i18n.t("similar.products")}
            </h3>
            <div className={styles["localization-items-list"]}>
              {groupSimilarItems.map(item => {
                return (
                  <ItemLocalization
                    key={`${item.sku}-${item.loc_id}`}
                    item={item}
                    quantity={item.tags.length}
                  />
                );
              })}
            </div>
          </div>
        )}

        {groupItems.length > 0 && isMobile && (
          <div className={styles["localization-items-content"]}>
            <div className={styles["localization-items-buttons-wrapper"]}>
              <div
                className={styles["localization-items-button"] + ' ' + styles["localization-items-clean"]}
                onClick={handleDeleteAll}
              >
                {" "}
                {i18n.t("clean")}{" "}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocalizationItems;
